
import { Container, Sprite } from 'pixi.js';
import { SwirlTrailParticle } from './SwirlTrailParticle';
import { RippleGen } from './RippleGen';
import { app } from './../app';

export class Portal extends Container {
    constructor(packData, screen) {
        super();

        this.scale.set(0);

        this.logo = new Sprite.from(packData.logo);
        this.logo.anchor.set(0.5);
        this.logo.scale.set(0.8);
        this.logo.x = packData.logoPos.x; this.logo.y = packData.logoPos.y;

        this.swirl = new Sprite.from("swirl-effect");
        this.swirl.anchor.set(0.5);
        app.tween(this.swirl, { loop: true })
            .to({ rotation: 2 * Math.PI }, 5000);

        this.fg = new Sprite.from(packData.foreground);
        this.fg.x = packData.fgPos.x; this.fg.y = packData.fgPos.y;
        this.fg.anchor.set(0.5);
        this.fg.scale.set(packData.fgScale);

        this.lights = new Sprite.from("light_beams");
        this.lights.anchor.set(0.5);
        // this.lights.alpha = 0;
        // app.tween(this.swirl, { loop: true })
        //     .to({ rotation: 2 * Math.PI }, 5000);

        this.masker = new Sprite.from('portal-test');
        this.masker.name = "masker";
        this.masker.anchor.set(0.5);
        this.masker.scale.x = 2; this.masker.scale.y = 2;

        this.bg = new Sprite.from(packData.background);
        this.bg.name = "background";
        this.bg.anchor.set(0.5);
        this.bg.scale.x = 1; this.bg.scale.y = 1;

        this.addChild(this.lights);
        this.addChild(this.masker);
        this.addChild(this.bg);
        this.addChild(this.swirl);
        this.addChild(this.fg);
        this.addChild(this.logo);

        if (app.performanceManager.performanceLevel > 1) {
            this.particleL = new SwirlTrailParticle();
            this.swirl.addChild(this.particleL);
            this.particleL.x = this.swirl.width / 2.2;
            this.particleL.rotation = Math.PI;
            this.particleL.play();
            screen.particles.push(this.particleL);

            this.particleR = new SwirlTrailParticle();
            this.swirl.addChild(this.particleR);
            this.particleR.x = -this.swirl.width / 2.2;
            this.particleR.play();
            screen.particles.push(this.particleR);
            var ripple = new RippleGen(this.masker.width, this.masker.height, this.bg);
            screen.ripples.push(ripple);
        }

        app.tween(this.scale)
            .wait(100)
            .to({ x: 1, y: 1 }, 250, createjs.Ease.sineOut);
        this.bg.mask = this.masker;

        app.tween(this.lights.scale)
            .to({ x: 0, y: 0 }, 0, createjs.Ease.sineOut)
            .wait(350)
            .to({ x: 2.1, y: 2.1 }, 250, createjs.Ease.sineOut);

    }

    hideIcons() {
        app.tween(this.fg.scale)
            .to({ x: 0, y: 0 }, 150, createjs.Ease.sineOut);
        app.tween(this.logo.scale)
            .to({ x: 0, y: 0 }, 150, createjs.Ease.sineOut);
        app.tween(this.lights.scale)
            .wait(350)
            .to({ x: 0, y: 0 }, 150, createjs.Ease.sineOut);
    }

    flash() {
        this.flash = new Sprite.from("portal_flash");
        this.flash.anchor.set(0.5);
        this.addChild(this.flash);
        app.tween(this.flash)
            .to({ alpha: 0 }, 250, createjs.Ease.sineOut);
    }
}
